import React from "react";
import { Link } from "react-router-dom";
import { Anchor, Brain, UserPlus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { getHomepageClarityCopy } from "@/components/public/homepageClarityTranslations";

const clarityIcons = [Brain, Anchor, UserPlus];

export default function HomepageClarityPanel({ prefix = "/en", language = "en" }) {
  const copy = getHomepageClarityCopy(language);
  const clarityItems = copy.items.map((item, index) => ({ ...item, icon: clarityIcons[index] || Brain }));
  return (
    <div className="mt-3 max-w-xl rounded-2xl border border-white/20 bg-white/10 p-3 !text-white shadow-xl shadow-ocean/15 backdrop-blur-2xl md:mt-4 md:p-4">
      <div className="grid gap-2 md:grid-cols-3">
        {clarityItems.map(({ icon: Icon, label, text }) => (
          <div key={label} className="rounded-xl bg-white/10 p-2.5 !text-white ring-1 ring-white/10">
            <Icon className="h-4 w-4 !text-cyan-100" />
            <p className="mt-1.5 text-xs font-black !text-white">{label}</p>
            <p className="mt-1 text-[11px] font-medium leading-4 !text-cyan-50/90">{text}</p>
          </div>
        ))}
      </div>
      <div className="mt-3 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-xs font-bold leading-5 !text-cyan-50/90">{copy.startText}</p>
        <Button asChild size="sm" className="h-9 w-full shrink-0 whitespace-nowrap rounded-xl bg-white px-3 text-xs !text-ocean hover:bg-cyan-50 hover:!text-ocean sm:w-auto">
          <Link to={`${prefix}/profile`}>{copy.cta}</Link>
        </Button>
      </div>
    </div>
  );
}